import Service from '@/shared/classes/service'

export default class ClientService extends Service {
  static prefix = 'clients'

  static destroy(companySlug: string, uuid: string): Promise<any> {
    return this.delete(`company/${ companySlug }/${ this.prefix }/${ uuid }`)
  }
}
